import { ReactNode } from 'react';
import { Link } from 'wouter';
import { ADMIN_ROUTES } from '../routes/consts';

type NavItemProps = {
  href: string;
  children: ReactNode;
  type?: 'internal' | 'legacy';
};

const AdminNavItem = (props: NavItemProps) => {
  const { href, children, type = 'internal' } = props;

  if (type === 'legacy') {
    return (
      <li>
        <a
          className='bg-gray-100 hover:bg-gray-200 text-black font-bold px-2 py-3 md:px-3 md:py-2 flex items-center border'
          href={href}
        >
          {children}
        </a>
      </li>
    );
  }

  return (
    <li>
      <Link
        className='bg-gray-100 hover:bg-gray-200 text-black font-bold px-2 py-3 md:px-3 md:py-2 flex items-center border'
        to={href}
      >
        {children}
      </Link>
    </li>
  );
};

export const AdminNav = () => {
  return (
    <nav className='p-4 flex justify-center'>
      <ul className='whitespace-nowrap flex text-sm box-border overflow-x-auto'>
        <AdminNavItem href={ADMIN_ROUTES.HOME}>Home</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.ORGANIZATIONS}>Organizations</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PROJECTS}>Projects</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.INTRODUCTIONS}>Introductions</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PROFESSIONALS}>Professionals</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.REPRESENTATIVES}>Representatives</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PARTNERS}>Partners</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COHORTS}>Cohorts</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.TEAMS}>Teams</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.JOB_POSTINGS}>Job&nbsp;Postings</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.EVENTS}>Events</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COMMUNITY_WINS}>Community&nbsp;Wins</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COMMUNITY_ANNOUNCEMENTS}>
          Community&nbsp;Announcements
        </AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.FUNDING_OPPORTUNITIES}>
          Funding&nbsp;Opportunities
        </AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.MEETINGS}>Meetings</AdminNavItem>
      </ul>
    </nav>
  );
};
